module.exports = __webpack_public_path__ + "static/img/pic12.9e519688.jpg";